<section class="background-color-white" *ngIf="haveHotels">
    <h1 [innerHTML]="'booking.hotelsList.title' | translate"></h1>
    <p [innerHTML]="'booking.hotelsList.intro' | translate"></p>
    <div class="hotels-wrapper">
        <ng-container *ngFor="let location of locationsList">
            <da-hotel *ngIf="location && location.hotels && location.hotels.length > 0" [location]="location"></da-hotel>
        </ng-container>
    </div>
</section>
